export enum StationType {
    PARENT_STATION = 'parentStation',
    STATION = 'station'
}
